export function messengerPathForRole(role) {
  const r = String(role || "").toUpperCase();
  if (r === "CAREGIVER") return "/caregiver/messenger";
  if (r === "CARE_MANAGER") return "/care-manager/messenger";
  if (r === "ADMIN" || r === "OPS") return "/admin/messenger";
  return "/messenger";
}

export function messengerConversationPath(role, peerUserId) {
  const base = messengerPathForRole(role);
  const id = Number(peerUserId);
  if (!Number.isFinite(id)) return base;
  return `${base}?peer=${encodeURIComponent(String(id))}`;
}

export const MESSENGER_ROUTE_PATHS = new Set([
  "/messenger",
  "/caregiver/messenger",
  "/care-manager/messenger",
  "/admin/messenger",
]);

export function isMessengerRoute(pathname) {
  return MESSENGER_ROUTE_PATHS.has(pathname);
}
